import { c as _c } from "react/compiler-runtime";
interface CfEmailProps {
  cfemail: string;
}

/**
 * Mirrors Cloudflare's email-protection placeholder verbatim. The Magento
 * source serves the same `<a class="__cf_email__" data-cfemail="..." href="...">[email&nbsp;protected]</a>`
 * markup; production decodes client-side via Cloudflare's email-decode.min.js
 * (loaded only on Cloudflare-fronted requests). We deliberately do NOT decode
 * here so the verify-content gate compares like-for-like against the source
 * capture and the data-cfemail attribute stays intact for downstream tooling.
 */
export function CfEmail(t0) {
  const $ = _c(2);
  const {
    cfemail
  } = t0;
  let t1;
  if ($[0] !== cfemail) {
    t1 = <a href="/cdn-cgi/l/email-protection" className="__cf_email__" data-cfemail={cfemail}>[email protected]</a>;
    $[0] = cfemail;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}